import styles from "./AboutUs.module.css";

import { useState } from "react";
import MissionValues from "../components/missionAndValues";

export default function AboutUs() {
  const [showFullHistory, setShowFullHistory] = useState(false);

  const toggleReadMore = () => {
    setShowFullHistory(!showFullHistory);
  };

  return (
    <section className={styles.AboutUsPage} id="about-us">
      <h2 className={styles.PageName}>About Us</h2>
      <div className={styles.aboutUsInfo}>
        <div className={styles.aboutUsinformation}>
          <div className={styles.introSection}>
            <img src="/icons/kpjadhavlogo.webp" alt="main logo" />
            <div className={styles.quote}>
              <h3 className={styles.slogan}>
                &#8220;&#2360;&#2350;&#2371;&#2342;&#2381;&#2343;
                &#2327;&#2366;&#2357;,
                &#2360;&#2350;&#2371;&#2342;&#2381;&#2343;
                &#2342;&#2375;&#2358;&#8221;
              </h3>
              <p className={styles.quoteBy}>- Dr. Sachin S. Jadhav</p>
            </div>

            <p>
              Saiseva Bahuuddeshiya Seva Pratishthan's,
              <br />
              K. P. Jadhav High School & Junior College
              <br />
              Chimbhale, Tal. Shrigonda, Dist. Ahilya Nagar, Maharashtra.
            </p>
          </div>

          <div className={styles.historySection}>
            <p>
              Established on December 27, 2007, the{" "}
              <a
                href="https://ngodetails.com/india/maharashtra/saiseva-bahuuddeshiya-seva-pratishthan/"
                target="_blank"
                rel="noreferrer"
              >
                Saiseva Bahuuddeshiya Seva Pratishthan
              </a>{" "}
              in Chimbhale has been addressing key social issues in health,
              education, welfare, culture, rural development, arts, sports, and
              women’s empowerment for over 13 years.
            </p>
            <p className={showFullHistory ? styles.expanded : styles.collapsed}>
              A key initiative of the foundation is K. P. Jadhav High School &
              Junior College, launched in June 2016. The institution has rapidly
              excelled, offering classes from 6th to 10th grade (semi-English
              medium) and 11th and 12th grades in Arts, Commerce, and Science
              streams. In addition to K. P. Jadhav High School & Junior College,
              the trust also operates{" "}
              <a href="/hangeshwarPublicSchool">Hangeshwar Public School</a>.
            </p>
            <button className={styles.readMoreButton} onClick={toggleReadMore}>
              {showFullHistory ? "Read Less" : "Read More"}
              {showFullHistory ? (
                <img src="/icons/readLess.png" alt="read less" />
              ) : (
                <img src="/icons/readMore.png" alt="read more" />
              )}
            </button>
          </div>
        </div>

        <MissionValues />
      </div>
    </section>
  );
}
